module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.findocs) ? _c('section', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.findocs), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v("\n            " + _vm._s(_vm.human_readable_date(item.dIssue)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "money"
    }, [_vm._v("\n            " + _vm._s(_vm.prachy(item.value)) + "\n          ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/api/findocs/' + item.id
      }
    }, [(item.is_invoice) ? _c('span', [_vm._v("faktura")]) : _vm._e(), _vm._v(" "), (item.is_payadvice) ? _c('span', [_vm._v("předpis plateb")]) : _vm._e(), _vm._v(" "), (item.is_debt_reminder) ? _c('span', {
      staticClass: "label-debt-reminder"
    }, [_vm._v("upomínka plateb")]) : _vm._e(), _vm._v("\n            č. " + _vm._s(item.id) + "\n            ")]), _vm._v("\n            pro: " + _vm._s(item.to.name) + ", " + _vm._s(item.to.address) + ", " + _vm._s(item.to.city) + "\n            "), (item.sent.email) ? _c('div', {
      staticClass: "grey"
    }, [_vm._v("\n              odesláno " + _vm._s(_vm.human_readable_date_time(item.sent.email)) + " na e-mail " + _vm._s(item.sent.emailTo) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.sent.printed) ? _c('div', {
      staticClass: "grey"
    }, [_vm._v("\n              odesláno " + _vm._s(_vm.human_readable_date(item.sent.printedDate)) + " poštou na adresu " + _vm._s(item.sent.printedAddr) + "\n            ")]) : _vm._e()])])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n            datum vystavení\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "money"
  }, [_vm._v("\n            částka\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            popis\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c88d51b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyFindocs.vue
// module id = 328
// module chunks = 1 2